import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ArrowDown = function ArrowDown(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 2.00684C11.1729 2.00684 10.6143 2.57617 10.6143 3.4248V16.0039L10.7109 18.335L8.25098 15.5527L5.8125 13.125C5.55469 12.8672 5.23242 12.6953 4.82422 12.6953C4.07227 12.6953 3.51367 13.2539 3.51367 14.0381C3.51367 14.3926 3.65332 14.7363 3.94336 15.0264L10.9688 22.0625C11.2373 22.3418 11.6133 22.4922 11.9893 22.4922C12.3652 22.4922 12.752 22.3418 13.0098 22.0625L20.0459 15.0264C20.3359 14.7363 20.4756 14.3926 20.4756 14.0381C20.4756 13.2539 19.917 12.6953 19.165 12.6953C18.7568 12.6953 18.4238 12.8672 18.1768 13.125L15.7275 15.5527L13.2783 18.335L13.3643 16.0039V3.4248C13.3643 2.57617 12.8057 2.00684 11.9893 2.00684Z"
  })));
};

ArrowDown.displayName = 'ArrowDown';
export default ArrowDown;